module.exports = __webpack_public_path__ + "img/temperature-full.5b3af46b.svg";